/**
 * mono 스킨 — 흑백·하이 컨트라스트.
 *
 * 감성 키워드:
 * - 샤프한 모서리(borderRadius 2)
 * - 두꺼운 검정 테두리 + 오프셋 그림자(neo-brutalism 풍)
 * - primaryColor 는 유지(직교) — 흑백 톤은 decoration 에만 적용
 *
 * 접근성: WCAG 대비 4.5:1 유지 (Phase 4 검증)
 *
 * CSS overlay 위치: styles/skins.css — `body[data-skin="mono"]` 블록
 */
import type { SkinDef } from './types'

export const monoSkin: SkinDef = {
  key: 'mono',
  label: '모노',
  description: '흑백 고대비 + 강한 그림자',
  swatch: { bg: '#ffffff', fg: '#000000', accent: '#1f1f1f' },
  token: {
    borderRadius: 2,
    borderRadiusLG: 4,
    borderRadiusSM: 0,
    fontWeightStrong: 700
  },
  componentDefaults: {
    Card: {
      borderRadiusLG: 4
    },
    Button: {
      borderRadius: 2,
      fontWeight: 700
    }
  }
}
